import { render } from "./SiteHeader.vue?vue&type=template&id=af41a7a6&scoped=true"
import script from "./SiteHeader.vue?vue&type=script&lang=js"
export * from "./SiteHeader.vue?vue&type=script&lang=js"

import "./SiteHeader.vue?vue&type=style&index=0&id=af41a7a6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-af41a7a6"

export default script